import { getStandaloneKycMetadata } from '@dealstack/frontend/shared/dataExchange/services/shareholder/investment.service';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import { useQuery } from '@tanstack/react-query';
import { useInvestorCustomDetails } from '@dealstack/frontend/investor/pages/Investment/hooks/useInvestorCustomDetails';

export const useStandaloneKycMetadata = (kycWorkflowId?: string) => {
	const metadataQuery = useQuery({
		queryKey: [
			formatUnicorn(API_PATHS.SHAREHOLDER_KYC_STANDALONE_KYCWORKFLOWID_GET, {
				kycWorkflowId: kycWorkflowId ?? '',
			}),
			{ kycWorkflowId: kycWorkflowId ?? '' },
		],
		queryFn: ({ signal }) =>
			getStandaloneKycMetadata({ kycWorkflowId: kycWorkflowId ?? '' }, signal),
		enabled: !!kycWorkflowId,
	});

	const customDetailsQuery = useInvestorCustomDetails(kycWorkflowId, {
		enabled: !!kycWorkflowId,
	});

	const metadata = metadataQuery.data?.payload;

	return {
		metadata,
		kycSetting: metadata?.kycSetting,
		isPiv: metadata?.isPiv ?? false,
		customDetailsQuery,
		isLoading: metadataQuery.isLoading,
	};
};
